import { createSelector } from '@reduxjs/toolkit'
import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

/** The year the page shows: the reader's pick, otherwise `JBPSettings.CurrentFYear`, which is 0
 *  until the settings load. */
export const selectMarketYoyGrowthSelectedFYear = createSelector(
  [selectMarketYoyGrowthExpectationState, selectJBPSettingsCurrentFYear],
  (state, currentFYear) => state.selectedFYear ?? currentFYear
)
